/**
 * KYC Service
 * Handles all KYC (Know Your Customer) related API calls
 */

import { apiGet, apiPost, apiPut, apiDelete } from './apiClient';
import API_CONFIG from './apiConfig';

/**
 * Submit KYC documents for verification
 * @param {FormData} formData - FormData containing: documentFront (file), documentBack (file), documentType, documentNumber, fullName, dateOfBirth, address
 * @returns {Promise}
 */
export const submitKYC = async (formData) => {
  return apiPost(API_CONFIG.endpoints.kyc, formData, {
    useFormData: true,
  });
};

/**
 * Get KYC verification status
 * @returns {Promise}
 */
export const getKYCStatus = async () => {
  return apiGet(API_CONFIG.endpoints.kyc);
};

/**
 * Update KYC documents
 * @param {FormData} formData - FormData containing: documentFront (file), documentBack (file), documentType, documentNumber
 * @returns {Promise}
 */
export const updateKYC = async (formData) => {
  return apiPut(API_CONFIG.endpoints.kyc, formData, {
    useFormData: true,
  });
};

/**
 * Delete KYC submission
 * @returns {Promise}
 */
export const deleteKYC = async () => {
  return apiDelete(API_CONFIG.endpoints.kyc);
};

/**
 * Get detailed KYC information
 * @returns {Promise}
 */
export const getKYCDetails = async () => {
  return apiGet(API_CONFIG.endpoints.kycDetails);
};

/**
 * Get KYC document by type (front or back)
 * @param {string} documentType - 'front' or 'back'
 * @returns {Promise}
 */
export const getKYCDocument = async (documentType) => {
  return apiGet(API_CONFIG.endpoints.kycDocument(documentType));
};

